export default "__VITE_ASSET__BLJZIrU9__"